/**
 * Форматує числове значення як грошову суму в гривні.
 * Додає пробіли-роздільники для тисяч та символ "грн".
 * @param {number | null | undefined} value - Число для форматування.
 * @returns {string} Відформатований рядок (напр., "1 234 грн") або порожній рядок, якщо вхідне значення некоректне.
 */
function formatUah(value) {
  // Перевіряємо, чи є вхідне значення коректним числом
  if (value == null || typeof value !== "number") {
    return "";
  }

  // Використовуємо toLocaleString для додавання пробілів та додаємо валюту
  return `${value.toLocaleString("uk-UA")} грн`;
}

/**
 * Форматує число (дріб) як відсоток.
 * @param {number | null | undefined} value - Число для форматування (напр., 0.25).
 * @returns {string} Відформатований рядок у відсотках (напр., "25%").
 */
function formatProcent(value) {
  // Перевіряємо на null, undefined, не-число або нескінченність
  if (value == null || typeof value !== "number" || !isFinite(value)) {
    return "0%";
  }

  // Множимо на 100 і форматуємо без знаків після коми
  return (value * 100).toLocaleString("uk-UA", { maximumFractionDigits: 0 }) + "%";
}

/**
 * Форматує дату разом з часом у зручний вигляд (ДД.ММ.РРРР, ГГ:ХХ)
 * @param {string} isoString - Дата в форматі ISO
 * @returns {string} Відформатована дата з часом.
 */
const formatDateTime = (isoString) => {
  if (!isoString) return "—";
  return new Date(isoString).toLocaleString("uk-UA", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * Форматує лише дату у зручний вигляд (ДД.ММ.РРРР)
 * @param {string} dateString - Дата в форматі ISO або іншому зрозумілому для Date
 * @returns {string} Відформатована дата або "—" у разі відсутності.
 */
const formatDate = (dateString) => {
  if (!dateString) return "—";
  return new Date(dateString).toLocaleDateString("uk-UA", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export { formatUah, formatProcent, formatDateTime, formatDate };
